import Joi from 'joi';

const documentNumberValidator = Joi.extend({
  messages: {
    invalidDocumentNumber: 'Ingresa número de documento sin puntos',
    invalidMinDocumentNumber: 'Debe contener al menos 6 caracteres',
    invalidMaxDocumentNumber: 'Debe contener al máximo 12 caracteres',
  },
  type: 'string',
  rules: {
    validateDocumentNumber: {
      validate(value, helpers) {
        if (value.length < 6) return helpers.error('invalidMinDocumentNumber');
        if (value.length > 12) return helpers.error('invalidMaxDocumentNumber');
        if (!value.includes('.')) return true;

        return helpers.error('invalidDocumentNumber');
      },
    },
  },
});

export const schema = Joi.object({
  documentNumber: documentNumberValidator
    .string()
    .required()
    .validateDocumentNumber(),
});
